import { DialogContent, DialogContentText, Grid } from '@mui/material'
import DialogBaseCC from 'components/Dialog/DialogBaseCC'
import { DIALOG_ID } from 'components/Dialog/constant'
import { NS_TRANS } from 'constants/common'
import { MySMEButton } from 'pages/authentication/login/mySMEButton'
import useSMEIAM from 'pages/authentication/useSMEIAM'
import { useTranslation } from 'react-i18next'
import { color } from 'theme'

const DialogLoginSSO = () => {
    const { t } = useTranslation(NS_TRANS.PG_MEETING)
    const { login: loginSME } = useSMEIAM()

    return (
        <DialogBaseCC id={DIALOG_ID.LOGIN_SSO} title={t('login.sso')}>
            <DialogContent>
                <DialogContentText sx={{ color: color.default, minHeight: '200px', minWidth: '400px' }}>
                    <Grid container mt={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Grid id="viettel-sme" item xs={4.5}>
                            <MySMEButton size={23} login={loginSME}/>
                        </Grid>
                    </Grid>
                </DialogContentText>
            </DialogContent>
        </DialogBaseCC>
    )
}

export default DialogLoginSSO